import React from "react";
import tal from "../../img/tal.png";
import { title, verticalLine, image } from "../Shared/Styles";

export default function Title(props) {
  
  if (props.productDetails !== undefined) {
    return (
      <div className="Title">
        <div>
        {(props.productDetails[0].brandName === null || "TAL") && (<img style={image} src={tal} alt={"tal"} />)}
        </div>

        <div style={verticalLine}>
          <h1 style={title}>Policy Summary</h1>
          {(props.productDetails[0].brandName === null || "TAL") && (<p style={title}>
            TAL Life Limited ABN 70 050 109 450 AFSL Number 237848
          </p>)
          }
        </div>
      </div>
    );
  }
}
